import { gatewayApi as api } from './gatewayApi';

export interface ToolType {
  Id?: number;
  Name: string;
  Description?: string;
  Active: boolean;
  CreatedDate?: string;
  ModifiedDate?: string;
}

export interface ToolTypeListResponse {
  data: ToolType[];
  total: number;
}

export interface ToolTypeSearchParams {
  page?: number;
  pageSize?: number;
  search?: string;
  active?: boolean;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

export const toolTypeApi = {
  getAll: (params?: ToolTypeSearchParams): Promise<ToolTypeListResponse> =>
    api.get('/tooltype', params),

  getById: (id: number): Promise<ToolType> =>
    api.get(`/tooltype/${id}`),

  create: (item: Omit<ToolType, 'Id'>): Promise<ToolType> =>
    api.post('/tooltype', item),

  update: (id: number, item: Partial<ToolType>): Promise<ToolType> =>
    api.put(`/tooltype/${id}`, item),

  delete: (id: number): Promise<{ success: boolean; message: string }> =>
    api.delete(`/tooltype/${id}`),

  search: (params: ToolTypeSearchParams): Promise<ToolTypeListResponse> =>
    api.post('/tooltype/search', params),

  bulkActivate: (ids: number[]): Promise<{ success: boolean; message: string }> =>
    api.put('/tooltype/bulk-activate', { ids }),

  bulkDeactivate: (ids: number[]): Promise<{ success: boolean; message: string }> =>
    api.put('/tooltype/bulk-deactivate', { ids }),

  bulkDelete: (ids: number[]): Promise<{ success: boolean; message: string }> =>
    api.post('/tooltype/bulk-delete', { ids }),

  getStatistics: (): Promise<{ total: number; active: number; inactive: number }> =>
    api.get('/tooltype/statistics'),

  exportToCSV: (params?: ToolTypeSearchParams): Promise<Blob> =>
    api.getBlob('/tooltype/export', { params }),

  validation: {
    validate: (item: Partial<ToolType>): string[] => {
      const errors: string[] = [];
      if (!item.Name || item.Name.trim().length === 0) errors.push('Name is required');
      if (item.Description && item.Description.length > 500) errors.push('Description must be less than 500 characters');
      if (item.Active === undefined || item.Active === null) errors.push('Active status is required');
      return errors;
    },
  },
};

export default toolTypeApi; 